import customAxios from "../../customAxios";

import { LOCATION_NEIGHBORHOOD } from "../../routes";
import {locationNamespace} from "../../../types/location.namespace";

const searchNeighborhood = async (props: locationNamespace.neighborhood.request): Promise<any> => {
  let thisUrl = `${LOCATION_NEIGHBORHOOD}?`;

  if (props?.search && props.search.trim().length > 0) thisUrl += `&search=${props.search}`;

  if (props?.province) thisUrl += `&province=${props?.province}`;
  if (props?.limit   ) thisUrl += `&limit=${props?.limit}`;
  if (props?.city    ) thisUrl += `&city=${props?.city}`;
  if (props?.town    ) thisUrl += `&town=${props?.town}`;
  if (props?.page    ) thisUrl += `&page=${props.page}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({LOCATION_NEIGHBORHOOD: error});
  }
};

export default searchNeighborhood;
